var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtSymbolOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8C10.6667 7.29276 10.3857 6.61448 9.88562 6.11438C9.38552 5.61429 8.70725 5.33334 8 5.33334C7.29276 5.33334 6.61448 5.61429 6.11438 6.11438C5.61429 6.61448 5.33334 7.29276 5.33334 8C5.33334 8.70725 5.61429 9.38552 6.11438 9.88562C6.61448 10.3857 7.29276 10.6667 8 10.6667C8.70725 10.6667 9.38552 10.3857 9.88562 9.88562C10.3857 9.38552 10.6667 8.70725 10.6667 8ZM10.6667 8V9C10.6667 9.44203 10.8423 9.86595 11.1548 10.1785C11.4674 10.4911 11.8913 10.6667 12.3333 10.6667C12.7754 10.6667 13.1993 10.4911 13.5118 10.1785C13.8244 9.86595 14 9.44203 14 9V8C14 6.81331 13.6481 5.65328 12.9888 4.66658C12.3295 3.67989 11.3925 2.91085 10.2961 2.45673C9.19975 2.0026 7.99335 1.88378 6.82946 2.11529C5.66558 2.3468 4.59648 2.91825 3.75736 3.75736C2.91825 4.59648 2.3468 5.66558 2.11529 6.82946C1.88378 7.99335 2.0026 9.19975 2.45673 10.2961C2.91085 11.3925 3.67989 12.3295 4.66658 12.9888C5.65328 13.6481 6.81331 14 8 14C9.05347 14.001 10.0885 13.7241 11 13.196",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtSymbolOutline);
export default __webpack_public_path__ + "static/media/AtSymbolOutline.0eacef110d4dcd20c77ee05a3a292ffa.svg";
export { ForwardRef as ReactComponent };